import { axios } from '@/services/axios';

const requestNewNumberBlock = async ({ currentCompany, submitData }) => {
    const res = await axios.post(
        `/numberblock/requestnew/${currentCompany}`,
        submitData,
    );
    return res;
};

export default requestNewNumberBlock;
